import React, {ReactNode} from 'react'
import styled from 'styled-components'
import {useFocusFirstFormInput} from '../../../../lib/hooks'
import {fontMedium, fontSmall} from '../library/css'
import {R1} from '../panels-layout'

const PropertiesHeaderWrapper = styled.div`
  padding-bottom: 14px;
  margin-bottom: 20px;
  border-bottom: solid 1px ${({theme}) => theme.colors.grey6};
`

const PropertiesTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 30px;

  h3 {
    ${fontMedium}
    margin: 0;
    padding: 0;
  }
`

const PropertiesDescription = styled.p`
  ${fontSmall}
  line-height: 20px;
  padding: 0px;
  margin: 6px 0px;
`

export const PropertiesHeader = ({
  children,
  description
}: {
  children: ReactNode
  description?: ReactNode
}) => (
  <PropertiesHeaderWrapper>
    <PropertiesTitle>
      {typeof children === 'string' ? <h3>{children}</h3> : children}
    </PropertiesTitle>
    {description ? (
      <PropertiesDescription>{description}</PropertiesDescription>
    ) : null}
  </PropertiesHeaderWrapper>
)

const PanelWrapper = styled.form`
  height: 100%;
`

export const Fields = styled.div<{compact?: boolean}>`
  display: flex;
  flex-direction: column;
  gap: ${({compact}) => (compact ? '4px' : '12px')};
  ${fontSmall}
`

export const Divider = styled.hr`
  border: 0;
  height: 0;
  border-top: 1px solid ${({theme}) => theme.colors.grey6};
  width: 100%;
  margin: 4px 0px;
`

export const PropertiesWrap = styled.div`
  padding: 12px 20px;
  margin-bottom: 50px;
`

export const MainProperties = ({children}: {children?: ReactNode}) => {
  const ref = useFocusFirstFormInput({key: window.location.pathname})
  // re-run the focus first hook when the path changes 👆
  // this is required as we render different "forms" based on the path
  return (
    <R1>
      <PanelWrapper ref={ref} onSubmit={e => e.preventDefault()}>
        {children}
      </PanelWrapper>
    </R1>
  )
}
